import React from 'react'

const ErrorImage = () => (
  <div className="photo-oftheday-slider-img">
    <img src={`${process.env.REACT_APP_BASE_URL}/resources/img/no-image.jpg`} alt="" />
  </div>
)

export default ErrorImage
